
import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import ReactToPrint from 'react-to-print';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';


import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';




import ReactHTMLTableToExcel from 'react-html-table-to-excel';
const headCells = [

  { id: 'sts_date', numeric: false, label: 'Slot Date' }, 
  { id: 'sm_slotname', numeric: false, label: 'Slot Name' },
 { id: 'st_name', numeric: false, label: 'Yoga Trainer Name' },
  { id: 'classtype', numeric: false, label: 'Class Type' },
  
  { id: 'lc_title', numeric: false, label: 'Location' },  
  { id: 'sb_title', numeric: false, label: 'Title' },  
  { id: 'sts_isaccept', numeric: false, label: 'Status' },  
  { id: 'sts_acceptedby', numeric: false, label: 'Accepted By' },  
  
    

 ]

function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  }, 


});




export default class StaffReport extends Component {
	
    constructor(props) {
    super(props);
    var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
     this.state = {
		 subscribeData:[],sts_date:dayjs(Date.now()),sts_date1:'',
		 prevpage:0,totaldata:0,rowsPaging:[],search:'',order:'desc' ,orderBy:'sts_id',subid:'',
		 
		 sb_title:'',sts_isaccept:'',sts_acceptedby:'',
		 staffarray:[],staff:'',fb_st_id:'',
		 
		 ExportData:[],StaffData:[] ,id:'',sts_st_id:'',page:0,rowsPerPage:10,
sm_slotname:'',st_name:'',lc_title:'',order:'desc' ,orderBy:'',redirect:false,type:'',
	          
   }
	  
	}
	  



	


handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };     
  
  	 myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 

  this.setState({[nam]: val});
  
}
  handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  

componentWillMount  () {
	

	
	document.title = "AthaYog Living - Staffschedule";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }

	this.onloadStaffbind();

	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);

  
}



apicall(page,rowsPerPage){
	
  axios.get(Serverurl+'ajaxstaffschedule.php?action=report&sts_date='+this.state.sts_date1+'&sts_st_id='+this.state.staff+'&sts_lc_id='+this.state.lc_title+'&sts_sb_id='+this.state.subid+'&StartIndex='+page+'&PageSize='+rowsPerPage)

  .then(resp => {  
		
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({
				
			  StaffData:resp.data,  
			totaldata:parseInt(resp.data[0].count)
			   

		    });
		
			
		this.apiExportcall();
		
	 
     }
	 else{
		   this.setState({StaffData:[],totaldata:0});
	 }
 
    });
}

  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};	  
	 

apiExportcall(){
	
 axios.get(Serverurl+'ajaxstaffschedule.php?action=report')

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  ExportData:resp.data,  
			   
			   

		    });

     }
	 else{
		   this.setState({ExportData:[]});
	 }
 
    });
}


onloadStaffbind(){

    axios.get(Serverurl+'ajaxstaff.php?action=getall&st_role=3')
	
    
      .then((response) => {    
     
      this.setState({ staffarray: response.data,  },()=>{
		  
		  let roleFromApi = this.state.staffarray.map(st => {
                            
          return {value: st.st_id, display:st.st_name}
        });
      
        this.setState({
          staffarray: [{value: '', display: 'All'}].concat(roleFromApi)
        });
		  
		  
	  });
	  
		this.onloadsubscribeBind();
      })   
    
    
} 



onloadsubscribeBind(){
  axios.post(Serverurl+'ajaxsubscription.php?action=getall&sb_type=1,2,3,4,6&sorting=sb_type')
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({
						subscribeData:resp.data	
							},()=>{
								
								
								 let subscribeFromApi = this.state.subscribeData.map(row => {
                          
          return {value:row.sb_id,display:row.sb_title,label:row.type,type:row.sb_type}
						 
        });
      
	
        this.setState({
          subscribeData: [{value: '', display:'Select Duration',label:'',type:'0'}].concat(subscribeFromApi)
        },()=>{});
								
							})
	
														
			}else{
				this.setState({subscribeData:[]});
			}
 
    });

}


 
  
    handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
  
  



handleClickSearch=()=>{   
   
  this.apicall(this.state.page,this.state.rowsPerPage); 
	
} 



onChangeClass = (event: React.ChangeEvent<HTMLInputElement>) => {
	
		 this.setState({lc_title: event.target.value},()=>{ 
		
		
		 });
	}
	
	
	
	
	
	
	
	
	handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({sts_date:dayjs(date),
sts_date1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
	
	
	
	
	

render() {
	
	 let prev="";
	if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return(
 
 
 <React.Fragment>
 
  <div className="mainheading"><h1>Yoga Trainer Schedule Report</h1></div>

<div className="clear"></div>

	
	

 <div className="searchmaster">
 <ul>
 <li>
 <p>Date</p>

 <LocalizationProvider dateAdapter={AdapterDayjs} >
      <DemoContainer components={['DatePicker']}>
<DatePicker fullWidth 
value= {dayjs(this.state.sts_date) }
 className="txtbox"name="sts_date"
    onChange={this.handdateChanges} format="YYYY/MM/DD"

/>  </DemoContainer>
    </LocalizationProvider>

 </li>
 <li><p>Yoga Trainer</p>
 
 
 
 
 <p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 className="txtbox"
		  inputProps={{tabIndex: "2"}} 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.staff }}
          onChange={this.myChangeHandler}
          id="staff"
		   value={this.state.staff}
		  name="staff"
		
		
        >
		{this.state.staffarray.map(staff => (
            <option  
            
              value={staff.value}
            >
              {staff.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p></li> 
				<li>
<p><span className="validation">*</span> Class Type</p>

<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined" inputProps={{tabIndex: "2"}}
		  className="txtbox"
          margin="normal"
          onChange={this.onChangeClass}
          id="type"
		   value={this.state.lc_title}
		  name="lc_title"
		
        >
	
	<option value="">Select Your Type</option>
                  <option value={1}>Personal Training at Home</option>
          <option value={2}>Personal Training in studio</option>
 <option value={3}>Group</option>
 <option value={4}>Prenatal</option> <option value={5}>Product</option>
 <option value={6}>Personal Training Online</option>

        </Select>

		</FormControl>
		</p>
</li>
				
 <li><p>Duration</p>
 
 <p><FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native 	inputProps={{tabIndex: "3"}}
			value={this.state.subid}
			onChange={this.myChangeHandler}
			name='subid'
			
			fullwidth
			
			
			>
		
		
			{this.state.subscribeData.map((row,index) =>{
	
	
		this.state.subscribeData.filter(options => options.type == row.type);
	
	if(prev!=row.type)
	{
	prev=row.type
				return(
				 <React.Fragment>
				  <optgroup label={row.label}>
				 {this.state.subscribeData.filter(options => options.type == row.type).map((sub) =>{ return(
			
				
				<option  
            
				  value={sub.value}
				>
				  {sub.display}
				</option  >
				
				)})}
		</optgroup>
	 </React.Fragment>			 
	)
	}
	
	})}
			 </Select>
		</FormControl></p></li>
				


				
			





		
				
					<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button> &nbsp;
		<ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="frmSecondarybtn"
							table="StaffscheduleReport"
							filename="YogaTrainerschedule Report"
							sheet="Yoga Trainer Report"
							buttonText="EXPORT"/>
							
			
			
				</p>		
		</li>
		
		
		</ul>
		
</div>	

	

	<div ref={el => (this.componentRef = el)}  >
	
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.StaffData.length}
            />
                      <TableBody>
                     {stableSort(this.state.StaffData, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >
<TableCell style={{"width":"20px"}}>{item.stsdate}</TableCell>
<TableCell style={{"width":"20px"}}>{item.sm_slotname}</TableCell>
<TableCell style={{"width":"20px"}}>{item.st_name}</TableCell>
<TableCell style={{"width":"20px"}}>{item.classtype}</TableCell>
<TableCell style={{"width":"20px"}}>{item.lc_title}</TableCell>
<TableCell style={{"width":"20px"}}>{item.sb_title}</TableCell>
<TableCell style={{"width":"20px"}}>{item.staffaccepttype}</TableCell>
<TableCell style={{"width":"20px"}}>{item.adminaccepttype}</TableCell>


	


	

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
         rowsPerPageOptions={[50,100,200,300,400]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      /> 
  </Paper>
    
</div>



<div style={{"display":"none"}}>
			
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="StaffscheduleReport">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.ExportData.length}
            />
                      <TableBody>
                     {stableSort(this.state.ExportData, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >


<TableCell style={{"width":"20px"}}>{item.stsdate}</TableCell>
<TableCell style={{"width":"20px"}}>{item.sm_slotname}</TableCell>
<TableCell style={{"width":"20px"}}>{item.st_name}</TableCell>
<TableCell style={{"width":"20px"}}>{item.classtype}</TableCell>
<TableCell style={{"width":"20px"}}>{item.lc_title}</TableCell>
<TableCell style={{"width":"20px"}}>{item.sb_title}</TableCell>
<TableCell style={{"width":"20px"}}>{item.staffaccepttype}</TableCell>
<TableCell style={{"width":"20px"}}>{item.adminaccepttype}</TableCell>


	
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
 
  </Paper>
 
</div>




 </React.Fragment>
 



);


		}
	
}

